<template>
    <div class="theme_common_modal_scroll">
        <div class="theme_common_modal_content">
            <div class="theme_common_modal_center">
                <div class="theme_common_modal">
                    <div class="theme_common_modal_header">
                        <div class="row align-items-center">
                            <div class="col-12">
                                <h2 class="theme_common_modal_title">Roles & Permission</h2>
                            </div>
                        </div>
                        <span class="popup_close" @click="PopupCloseMethod"><i class="fa fa-times"></i></span>
                    </div>
                    <div class="theme_common_modal_body">
                        <form>
                            <div class="form-group">
                                <select class="form-control">
                                    <option>Please Select</option>
                                    <option>Content Creator</option>
                                    <option>Management</option>
                                    <option>Developer</option>
                                    <option>Super Admin</option>
                                </select>
                            </div>
                            <div class="row mt-1">
                                <div class="col-sm-12 text-right">
                                    <button type="submit" class="btn btn-default">Apply</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  name: 'roles-permission-popup',
  components: {},
  props: [],
  data() {
    return {
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    PopupCloseMethod() {
      bus.$emit('rolesPermissionPopupStateBus', false);
    },
  }
}
</script>
<style lang="scss" scoped>
.theme_common_modal_scroll {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.92);
    overflow-y: auto;
    height: 100vh;

    .theme_common_modal_content {
        display: table;
        width: 100%;
        height: 100%;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        color: #ffffff;

        .theme_common_modal_center {
            display: table-cell;
            vertical-align: middle;
        }

        .theme_common_modal {
            background: #000;
            max-width: 380px;
            margin: 0 auto;
            border-radius: 5px;
            box-shadow: 3px 3px 3px rgba(255, 255, 255, 0.04), -3px -3px 3px rgba(255, 255, 255, 0.04);
        }

        .theme_common_modal_header {
            padding: 15px;
            position: relative;
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);

            .theme_common_modal_title {
                font-size: 28px;
                letter-spacing: 0;
                margin-bottom: 0;
            }

            .popup_close {
                position: absolute;
                top: 15px;
                right: 10px;
                line-height: 1;

                .fa {
                    font-size: 20px;
                    color: red;
                    cursor: pointer;
                    transform: scale(1);
                    -webkit-transform: scale(1);
                    -moz-transform: scale(1);
                    -webkit-transition: all ease 0.5s;
                    transition: all ease 0.5s;

                    &:hover {
                        color: #3be8b0;
                    }
                }
            }
        }

        .theme_common_modal_body {
            padding: 15px;

            label {
                font-size: 16px;
                margin-bottom: 4px;
            }

            .form-control {
                height: auto;
                padding: 7px 15px;
                background: rgba(255, 255, 255, 0.1);
                border-color: transparent;
                font-size: 16px;
                color: #fff;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                -webkit-transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
                transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);

                option {
                    color: #000000;
                }
            }

            .invalid-feedback {
                font-size: 14px;
                line-height: 1;
            }

            .btn-primary {
                cursor: pointer;
                position: relative;
                min-width: 95px;
                -webkit-box-shadow: none !important;
                box-shadow: none !important;
                outline: none !important;
                background: #6a67ce !important;
                color: #ffffff !important;
                border: none;
                border-radius: 3px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-size: 18px;

                &:hover {
                    background: #3be8b0 !important;
                    color: #22292f !important;
                }
            }
        }
    }
}
</style>